import { render, staticRenderFns } from "./Mbaby.vue?vue&type=template&id=4b690659&"
import script from "./Mbaby.vue?vue&type=script&lang=js&"
export * from "./Mbaby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports